import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'formatDateArray',
    standalone: true
})
export class FormatDateArrayPipe implements PipeTransform {

    transform(dateArray: number[] | undefined, includeTime = false, zone = Intl.DateTimeFormat().resolvedOptions().timeZone): string {
        if (!dateArray || dateArray.length < 3) return '\u2014';
        const [year, month, day, hour = 0, minute = 0, second = 0] = dateArray;
        const utcDateTime = DateTime.utc(year, month, day, hour, minute, second);
        if (includeTime) {
            return utcDateTime.setZone(zone).toFormat('MM/dd/yyyy hh:mm:ss a');
        }
        return utcDateTime.toFormat('MM/dd/yyyy');
    }
}
